import Vue from 'vue'

/**
 * @author Andres Aguilar <andresyoshimar@gmail.com>
 */

const sendPayment = (payment) => {
  const payload = {
    amount: payment.amount,
    exchange_price: payment.exchangePrice,
    package: payment.package,
  }

  return Vue.$http.post('extranet/package/payments/', payload)
    .then(response => response.data)
    .catch((err) => { throw err })
}

export default sendPayment


// WEBPACK FOOTER //
// ./src/services/extranet/sendPayment.js